import { render, staticRenderFns } from "./Jackpot.vue?vue&type=template&id=70cf0e36&"
import script from "./Jackpot.vue?vue&type=script&lang=js&"
export * from "./Jackpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports